var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvasContainer",staticClass:"canvas-container",attrs:{"id":"canvas-container"}},[_c('canvas',{staticClass:"engine-canvas-box",attrs:{"id":"engineCanvas","oncontextmenu":"event.preventDefault()","tabindex":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }